import { lazy } from "react";

// project imports
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import RequireAuth from "components/RequireAuth";
import { UserProvider } from "contexts/UserContext";

// render- Dashboard
const DashboardDefault = Loadable(
  lazy(() => import("pages/dashboard/default")),
);

const Properties = Loadable(
  lazy(() => import("pages/accommodation/properties")),
);
const ShowProperty = Loadable(
  lazy(() => import("pages/accommodation/showProperty")),
);
const EditProperty = Loadable(
  lazy(() => import("pages/accommodation/editProperty")),
);
const Units = Loadable(lazy(() => import("pages/accommodation/units")));
const ShowUnit = Loadable(lazy(() => import("pages/accommodation/showUnit")));
const EditUnit = Loadable(lazy(() => import("pages/accommodation/editUnit")));

const Guests = Loadable(lazy(() => import("pages/guest/guests")));
const ShowGuest = Loadable(lazy(() => import("pages/guest/showGuest")));
const EditGuest = Loadable(lazy(() => import("pages/guest/editGuest")));

const Reservations = Loadable(
  lazy(() => import("pages/reservation/reservations")),
);

const EditReservation = Loadable(
  lazy(() => import("pages/reservation/editReservation")),
);
const ShowReservation = Loadable(
  lazy(() => import("pages/reservation/showReservation")),
);
const Calendar = Loadable(lazy(() => import("pages/reservation/calendar")));

const Users = Loadable(lazy(() => import("pages/user/users")));
const ShowUser = Loadable(lazy(() => import("pages/user/showUser")));
const EditUser = Loadable(lazy(() => import("pages/user/editUser")));

const ShowHost = Loadable(lazy(() => import("pages/host/showHost")));
const EditHost = Loadable(lazy(() => import("pages/host/editHost")));

const MainRoutes = {
  path: "/",
  element: (
    <RequireAuth>
      <UserProvider>
        <DashboardLayout />
      </UserProvider>
    </RequireAuth>
  ),
  children: [
    {
      path: "properties",
      element: <Properties />,
    },
    {
      path: "showProperty",
      element: <ShowProperty />,
    },
    {
      path: "editProperty",
      element: <EditProperty />,
    },
    {
      path: "units",
      element: <Units />,
    },
    {
      path: "showUnit",
      element: <ShowUnit />,
    },
    {
      path: "editUnit",
      element: <EditUnit />,
    },
    {
      path: "guests",
      element: <Guests />,
    },
    {
      path: "showGuest",
      element: <ShowGuest />,
    },
    {
      path: "editGuest",
      element: <EditGuest />,
    },
    {
      path: "reservations",
      element: <Reservations />,
    },
    {
      path: "editReservation",
      element: <EditReservation />,
    },
    {
      path: "showReservation",
      element: <ShowReservation />,
    },
    {
      path: "calendar",
      element: <Calendar />,
    },
    {
      path: "admin/users",
      element: <Users />,
    },
    {
      path: "admin/showUser",
      element: <ShowUser />,
    },
    {
      path: "admin/editUser",
      element: <EditUser />,
    },
    {
      path: "admin/showHost",
      element: <ShowHost />,
    },
    {
      path: "admin/editHost",
      element: <EditHost />,
    },
    {
      path: "/",
      element: <DashboardDefault />,
    },
    {
      path: "dashboard",
      children: [
        {
          path: "default",
          element: <DashboardDefault />,
        },
      ],
    },
  ],
};

export default MainRoutes;
